import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { DEFAULT_MAX_BET_AMOUNT, DEFAULT_MIN_BET_AMOUNT } from '../constants';
import { findCurrencyLimit } from '../lib/currencyLimits';
import {
  BALANCE_SLICE_KEY,
  balanceSelector,
  type BalanceSliceState,
} from '../store/slices/balanceSlice';
import {
  GAME_SLICE_KEY,
  gameSelector,
  type GameSliceState,
} from '../store/slices/gameSlice';

type BetLimitsState = {
  [BALANCE_SLICE_KEY]: BalanceSliceState;
  [GAME_SLICE_KEY]: GameSliceState;
};

export interface BetLimits {
  minBet: number;
  maxBet: number;
}

// Min and max stake for the player's currency. Falls back when there's no row.
export function useBetLimits(): BetLimits {
  const { balance } = useSelector<BetLimitsState, BalanceSliceState>(
    balanceSelector
  );
  const { gameConfig } = useSelector<BetLimitsState, GameSliceState>(
    gameSelector
  );

  return useMemo(() => {
    const limit = findCurrencyLimit(
      gameConfig.currencyLimits,
      balance.userCurrency
    );
    return {
      minBet: limit?.minAmount ?? DEFAULT_MIN_BET_AMOUNT,
      maxBet: limit?.maxAmount ?? DEFAULT_MAX_BET_AMOUNT,
    };
  }, [balance.userCurrency, gameConfig.currencyLimits]);
}
